import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NetworkInstructionModel } from '../../Models/Models/Network/NetworkInstructionModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class NetworkInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(model: NetworkInstructionModel): Promise<NetworkInstructionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<NetworkInstructionModel, any>(url, data);
  }
  public delete(instructionIds: Array<number>): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionIds: instructionIds }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
  public get(instructionId: number): Promise<NetworkInstructionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<NetworkInstructionModel, any>(url, data);
  }
  public put(parameter: NetworkInstructionModel): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { parameter: parameter }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

